import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST, { SEPERATOR } from '../../config/page-title.config';
import ListEventRegistrations from '../../components/content/list-event-registrations.component';

const EventRegistrationsView = () => {
  const { id } = useParams();
  const location = useLocation();

  const pageTitle = `${PAGE_TITLE_LIST.EVENT_REGISTRATIONS}${
    location?.state?.name ? ` ${SEPERATOR} ${location.state.name}` : ''
  }`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListEventRegistrations id={id} />
    </AppLayout>
  );
};

export default EventRegistrationsView;
